import React from "react";
import PropTypes from "prop-types";

const LeftArrow = ({ onClick }) => {
  return (
    <button
      type="button"
      className="space-tile__carousel__button space-tile__carousel__button--prev"
      data-testid="carouselLeftArrow"
      onClick={onClick}
    />
  );
};

LeftArrow.propTypes = {
  onClick: PropTypes.func.isRequired,
};
export default LeftArrow;
